import {useTranslation as useTranslationClient} from 'react-i18next';

export const useTranslation =  useTranslationClient;